module.exports = __webpack_public_path__ + "assets/1a96f1f895fe063bc86bb7be4570ae7f.woff2";